<template>
  <div>
    <van-form ref="myForm" :disabled="status === 'ENABLE'">
      <div class="information-box">
        <div class="information-title">{{ $t('form.title.person') }}</div>
        <div class="item">
          <van-field v-model="form.phone" :label="$t('form.label.phone')" :placeholder="$t('form.label.enter')">
            <template #label>
              {{ $t('form.label.phone') }}<img class="asterisk" :src="star" alt="" />
            </template>
          </van-field>
        </div>
        <div class="item">
          <van-field v-model="form.email" :placeholder="$t('form.label.enter')">
            <template #label>
              <div class="person-mail">
                <span>{{ $t('form.label.mail') + $t3('（作为登录账号）', '(for log-in)') }}<img class="asterisk" :src="star" alt="" /></span>
                <!-- <p>{{ $t('form.label.initialPas') }}</p> -->
              </div>
            </template>
          </van-field>
        </div>
        <div class="item">
          <van-field v-model="form.wechat" :label="$t('form.label.WeChat')" :placeholder="$t('form.label.enter')">
            <template #label>
              {{ $t('form.label.WeChat') }}
            </template>
          </van-field>
        </div>
      </div>
    </van-form>
  </div>
</template>

<script>

import { objectMergLeft } from '@/utils'
import { mapGetters } from 'vuex'

const tmpForm = {
  phone: undefined,
  email: undefined,
  wechat: undefined
}

export default {
  name: 'contactInfo',
  data() {
    return {
      star: require('@/assets/img/asterisk.svg'),
      form: {},
      rules: {
        phone: [
          { msg: ['手机号不能为空', 'Cell Number is required.'] },
          { regex: /^1[3-9][0-9]{9}$/, msg: ['手机号格式有误', 'Cell Number is not in the required format.'] }
        ],
        email: [
          { msg: ['邮箱不能为空', 'E-mail is required.'] },
          { regex: /^[^\s@]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/, msg: ['邮箱格式有误', 'E-mail is not in the required format.'] }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['status'])
  },
  methods: {
    initForm(form) {
      this.form = Object.assign({}, tmpForm)
      objectMergLeft(this.form, form)
    },
    validate() {
      return this.$validateI18n(this.form, this.rules)
    },
  }
}
</script>
<style lang="scss" scoped></style>